<div *ngIf="loading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div class="panel">
  <h1 class="mb-5 text-lg font-bold">{{ "pricing_header" | translate }}</h1>

  <div class="mb-6 mt-8 flex items-center justify-end" *appHasRole="[userRole.SuperAdmin]">
    <button *ngIf="isEditingAll && !isLoading" (click)="saveAllPlans()" class="btn btn-primary w-52 cursor-pointer ltr:ml-4 rtl:mr-4">
      {{ "save" | translate }}
    </button>
    <button type="button" *ngIf="isLoading" class="btn btn-primary w-52 cursor-not-allowed ltr:ml-4 rtl:mr-4">
      <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>Loading
    </button>
    <button *ngIf="isEditingAll && !isLoading" (click)="cancelEditingAll()" class="btn btn-danger w-52 cursor-pointer ltr:ml-4 rtl:mr-4">
      {{ "cancel" | translate }}
    </button>
    <ng-select
      *ngIf="isEditingAll && !isLoading && packageId"
      [items]="options$ | async"
      bindLabel="title"
      bindValue="id"
      [(ngModel)]="selectedTier"
      placeholder="Select Tier"
      [searchable]="false"
      [clearable]="false"
      class="custom-multiselect !w-52 text-lg ltr:ml-4 rtl:mr-4"
      placeholder="{{ 'packages.select_an_option' | translate }}"
      appendTo="body"
      (change)="onCategoryChange($event)"
    >
    </ng-select>

    <div class="flex">
      <a (click)="startEditingAll()" *ngIf="!isEditingAll" class="btn btn-primary cursor-pointer rounded-full p-2 ltr:ml-auto rtl:mr-auto">
        <icon-pencil-paper />
      </a>
    </div>
  </div>

  <div class="pricing-container">
    <div class="pricing-table">
      <div class="pricing-column" *ngFor="let tier of tiers">
        <h2>
          {{ "packages." + tier.title.toLowerCase() + "_title" | translate }}
        </h2>
        <p class="description">
          {{ "packages." + tier.title.toLowerCase() + "_description" | translate }}
        </p>

        <div class="pricing-buttons">
          <button class="btn-small" [class.active]="selectedCycle === 'monthly'" (click)="setCycle('monthly')">
            {{ "monthly" | translate }}
          </button>
          <button class="btn-small" [class.active]="selectedCycle === 'yearly'" (click)="setCycle('yearly')">
            {{ "yearly" | translate }}
          </button>
        </div>

        <ng-container *ngIf="selectedCycle === 'yearly'; else monthlyP">
          <div class="price">€{{ tier.monthlyPrice * 10 }}/{{ "yearly" | translate }}</div>
        </ng-container>

        <ng-template #monthlyP>
          <ng-container *ngIf="isEditingAll">
            <input type="number" [(ngModel)]="tier.monthlyPrice" />
          </ng-container>
          <ng-container *ngIf="!isEditingAll">
            <div class="price">€{{ tier.monthlyPrice }}/{{ "monthly" | translate }}</div>
          </ng-container>
        </ng-template>

        <div class="features">
          <!-- Number of entries -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "sales_entries_quantity_cap" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="number" [(ngModel)]="tier.salesEntriesQuantityCap" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                {{ tier.salesEntriesQuantityCap ?? "N/A" }}
              </ng-container>
            </span>
          </div>

          <!-- eTurist Entries Quantity -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "e_turist_entries_quantity_cap" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="number" [(ngModel)]="tier.eTuristEntriesQuantityCap" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                {{ tier.eTuristEntriesQuantityCap ?? "N/A" }}
              </ng-container>
            </span>
          </div>

          <!-- Branches Quantity -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "branches_quantity_cap" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="number" [(ngModel)]="tier.branchesQuantityCap" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                {{ tier.branchesQuantityCap ?? "N/A" }}
              </ng-container>
            </span>
          </div>

          <!-- Agent Quantity -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "agent_quantity_cap" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="number" [(ngModel)]="tier.agentQuantityCap" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                {{ tier.agentQuantityCap ?? "N/A" }}
              </ng-container>
            </span>
          </div>

          <!-- Passengers Database -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "passengers_database" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.passengersDatabase" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.passengersDatabase; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Services Database -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "services_database" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.servicesDatabase" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.servicesDatabase; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Statistics Database -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "statistics_database" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.statisticsDatabase" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.statisticsDatabase; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Sending of Announcement Documents -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "sending_of_announcement_documents" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.sendingOfAnnouncementDocuments" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.sendingOfAnnouncementDocuments; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Creation of Daily Sales Orders -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "creation_of_daily_sales_orders" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.creationOfDailySalesOrders" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.creationOfDailySalesOrders; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Creation of Daily Summaries -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "creation_of_daily_summaries" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.creationOfDailySummaries" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.creationOfDailySummaries; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Organizers Hotels Communication -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "organizers_hotels_communication" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.organizersHotelsCommunication" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.organizersHotelsCommunication; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Travelers Communication -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "travelers_communication" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.travelersCommunication" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.travelersCommunication; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Sub Agents Communication -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "sub_agents_communication" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.subAgentsCommunication" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.subAgentsCommunication; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- eTourist Accounting -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "e_tourist_accounting" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.eTouristAccounting" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.eTouristAccounting; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Statistics Accounting -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "statistics_accounting" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.statisticsAccounting" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.statisticsAccounting; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Calendar Accounting -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "calendar_accounting" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.calendarAccounting" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.calendarAccounting; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Customer Support -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "customer_support" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.customerSupport" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.customerSupport; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Sava Insurance -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "sava_insurance" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.savaInsurance" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.savaInsurance; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- eFiskal -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "fiscalization" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.eFiskal" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.eFiskal; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- OpenEnded -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "open_ended" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.openEnded" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.openEnded; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- OpenEnded -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "sms_messaging" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.smsMessaging" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.smsMessaging; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Travels-->
          <div class="feature-row">
            <button class="feature-label">
              {{ "travels" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enableTravels" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enableTravels; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Group Travels-->
          <div class="feature-row">
            <button class="feature-label">
              {{ "groupTravels" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enableGroupTravels" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enableGroupTravels; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Tickets-->
          <div class="feature-row">
            <button class="feature-label">
              {{ "tickets" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enableTickets" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enableTickets; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Transfers-->
          <div class="feature-row">
            <button class="feature-label">
              {{ "transfers" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enableTransfers" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enableTransfers; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Other Services-->
          <div class="feature-row">
            <button class="feature-label">
              {{ "otherServices" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enableOtherServices" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enableOtherServices; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Package arrangements -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "package_arrangement" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enablePackageArrangements" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enablePackageArrangements; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- Tours -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "tours" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.enableTours" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.enableTours; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>

          <!-- OnlineApplications -->
          <div class="feature-row">
            <button class="feature-label">
              {{ "online_application" | translate }}
            </button>
            <span class="feature-value">
              <ng-container *ngIf="isEditingAll">
                <input type="checkbox" class="peer form-checkbox" [(ngModel)]="tier.onlineApplications" />
              </ng-container>
              <ng-container *ngIf="!isEditingAll">
                <ng-container *ngIf="tier.onlineApplications; else noData">
                  <icon-check class="h-5 w-5"></icon-check>
                </ng-container>
                <ng-template #noData>
                  <icon-x class="bold h-6 w-6"></icon-x>
                </ng-template>
              </ng-container>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
